const START_BIN = "1010";
const END_BIN = "11101";
const BINARIES = [
  "00110",
  "10001",
  "01001",
  "11000",
  "00101",
  "10100",
  "01100",
  "00011",
  "10010",
  "01010"
];
export {
  BINARIES,
  END_BIN,
  START_BIN
};
